import React from "react";

function InputField({
  value,
  handleChange,
  name,
  type,
  id,
  label,
  required,
  width,
  height,
  disabled,
}) {
  return (
    <div className={`${width} ${height} `}>
      <div className="w-full h-full">
        <input
          className="w-full border border-gray-30 h-full p-3 outline-primary outline-1 rounded-lg placeholder:text-gray-50"
          type={type}
          id={id}
          name={name}
          onChange={handleChange}
          value={value}
          required={required}
          disabled={disabled}
          placeholder={label}
        />
      </div>
    </div>
  );
}

export default InputField;
